<template>
  <div
    class="sign-component"
    :style="{
      backgroundColor: background,
      border:borderWidth + 'px dashed '+ borderColor,
      borderRadius: borderRadius + 'px'
    }">
    <div v-if="!startReceiveData" class="placeholder-area">签名区</div>
    <canvas :id="id" ref="canvas" class="draw-canvas"></canvas>
  </div>
</template>

<script>
import websocketManager from '@/utils/websocket-manager'
import { socketBus } from '@/eventBus/index.js'
export default {
  name: 'SignNameComponent',
  props: {
    config: {
      type: Object,
    },
    globalConfig: {
      type: Object,
    },
  },
  data () {
    return {
      socket: null,
      screenId: this.$route.params.id,
      startReceiveData: false,
    }
  },
  computed: {
    background () {
      return this.config.chartSet.chartStyle.background
    },
    borderColor () {
      return this.config.chartSet.borderStyle.borderColor
    },
    borderRadius () {
      return this.config.chartSet.borderStyle.borderRadius
    },
    borderWidth () {
      return this.config.chartSet.borderStyle.borderWidth
    },
    id () {
      const { id, chartViewId } = this.config.chartViewData
      return `${id}${chartViewId}`
    },
    signName () {
      return this.config.chartSet.chartStyle.signName
    },
    textColor () {
      return this.config.chartSet.chartStyle.textColor
    },
    showWidth () {
      return this.config.chartWidth
    },
    showHeight () {
      return this.config.chartHeight
    },
  },
  created () {
    // 检查并建立socket连接
    this.socket = websocketManager.getInstance('/sign/web_socket')
  },
  mounted () {
    // 订阅消息梳理
    socketBus.$on('websocket-message', this.processMessage)
  },
  beforeDestroy () {
    // 清理事件监听器，避免内存泄漏
    socketBus.$off('websocket-message', this.processMessage)
  },
  methods: {
    processMessage (data) {
      const { userName, point, action, screenId } = data
      if (screenId === this.screenId && userName === this.signName) { // 匹配的上才进行数据处理
        this.startReceiveData = true
        const ctx = this.$refs.canvas.getContext('2d')
        const width = this.$refs.canvas.width
        const height = this.$refs.canvas.height
        ctx.lineWidth = 1
        ctx.strokeStyle = this.textColor ?? '#fff'
        if (action === 'clear') {
          ctx.clearRect(0, 0, this.showWidth, this.showHeight)
          this.startReceiveData = false
          return
        }
        if (action === 'stop') {
          ctx.closePath()
          return
        }
        // 需要计算缩放比例
        const scaledX = point.x * width
        const scaledY = point.y * height
        if (action === 'start') {
          ctx.beginPath()
          ctx.moveTo(scaledX, scaledY)
        } else if (action === 'draw') {
          ctx.lineTo(scaledX, scaledY)
          ctx.stroke()
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.sign-component{
  width: 100%;
  height: 100%;
  position:relative;
  .draw-canvas{
    width: 100%;
    height: 100%;
  }
  .placeholder-area{
    position:absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    color:#666;
    font-size:28px
  }
}
</style>
